import { render, staticRenderFns } from "./FacturaInternaView.vue?vue&type=template&id=88703518"
import script from "./FacturaInternaView.vue?vue&type=script&lang=js"
export * from "./FacturaInternaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports